var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPtBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 599.79,
    height: 399.864,
    viewBox: "0 0 599.79 399.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -85.331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,85.331H599.79V485.2H0Z",
    fill: "#6da544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.947,161.678,427.895,272.166,277.947,382.654,128,272.166Z",
    transform: "translate(21.947 13.091)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.135,
    cy: 63.135,
    r: 63.135,
    transform: "translate(236.76 222.122)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.779 222.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.67,261.29a106.2,106.2,0,0,0-31.548,4.768A63.115,63.115,0,0,0,316.938,301.45a106.386,106.386,0,0,0-83.269-40.16ZM327.2,277.332a63.14,63.14,0,0,0-119.984-37.016A130.145,130.145,0,0,1,327.2,277.332Z",
    transform: "translate(-202.122 -202.099)",
    fill: "#0052b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtBr);
export default __webpack_public_path__ + "static/media/pt-BR.3d30d78dbe96fc58cd71ad41631e39a1.svg";
export { ForwardRef as ReactComponent };